import { LocalState } from '@common/localstate/frontend-shared';
import { BehaviorSubject, combineLatest, delay, fromEvent, merge, Subject, take, takeUntil } from 'rxjs';
export const STATE_KEY_PLAYER_VOLUME = 'video-player-volume';
export const STATE_KEY_PLAYER_SUBTITLES = 'video-player-subtitles';
export class VimePlayerLocalState {
  constructor(localState, store, options) {
    this.localState = localState;
    this.store = store;
    this.options = options;
    this.onDestroy$ = new Subject();
    this.ready$ = new BehaviorSubject(false);
  }
  initialize(player) {
    combineLatest({
      volume: this.store.select(LocalState.get(STATE_KEY_PLAYER_VOLUME)),
      subtitles: this.store.select(LocalState.get(STATE_KEY_PLAYER_SUBTITLES))
    }).pipe(take(1), delay(1)).subscribe(state => {
      if (this.options.overrideVolume) {
        state.volume = this.options.overrideVolume;
      }
      if (state.volume && typeof state.volume.volume === 'number') {
        // in vime, setting muted/volume is related to each other.
        player.muted = state.volume.volume === 0;
        player.volume = state.volume.volume;
      }
      if (this.options.overrideSubtitles) {
        state.subtitles = this.options.overrideSubtitles;
      }
      if (state.subtitles) {
        player.setTextTrackVisibility(state.subtitles.enabled);
      } else {
        player.setTextTrackVisibility(false);
      }
      this.ready$.next(true);
    });
    this.ready$.pipe(take(1)).subscribe(() => this.initializeListeners(player));
  }
  initializeListeners(player) {
    if (!this.options.overrideVolume) {
      merge(fromEvent(player, 'vmVolumeChange'), fromEvent(player, 'vmMutedChange')).pipe(takeUntil(this.onDestroy$)).subscribe(e => {
        this.localState.set(STATE_KEY_PLAYER_VOLUME, {
          volume: player.muted ? 0 : player.volume
        });
      });
    }
    if (!this.options.overrideSubtitles) {
      merge(fromEvent(player, 'vmTextTrackVisibleChange')).pipe(takeUntil(this.onDestroy$)).subscribe(e => {
        this.localState.set(STATE_KEY_PLAYER_SUBTITLES, {
          enabled: player.isTextTrackVisible
        });
      });
    }
  }
  destroy() {
    this.onDestroy$.next(true);
  }
}